import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const getJournals = (t) => [
  {
    title: t('pages.journals.republic100.title'),
    coverImage: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/cumhuriyetdergi.png',
    journalLink: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/cumhuriyetin100yili.pdf',
    volume: t('pages.journals.republic100.volume'),
    editor: t('pages.journals.republic100.editor'),
    description: t('pages.journals.republic100.description'),
    isSpecialIssue: true,
    specialType: 'republic100'
  },
  {
    title: t('pages.journals.firstIssueJournal.title'),
    coverImage:'https://fs.hacettepe.edu.tr/fenyeni/books/kitap.png',
    journalLink:'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/0-birle%C5%9Ftirildi_compressed.pdf',
    description: t('pages.journals.firstIssueJournal.description'),
    indexes: [],
    isFirstIssue: true
  },
  {
    title: t('pages.journals.hjbc.title'),
    coverImage: 'https://dergipark.org.tr/media/cache/journal_croped/c1b8/cdaa/58c0/634d0955d034b.jpg',
    journalLink: 'https://dergipark.org.tr/en/pub/hjbc',
    description: t('pages.journals.hjbc.description'),
    indexes: [
      {
        name: 'TR Dizin',
        logo: 'https://dergipark.org.tr/media/cache/index_logo/8bc6/836b/4cf6/5bd95eb5f3a21.jpg',
        link: 'https://search.trdizin.gov.tr/tr/dergi/detay/189'
      }
    ]
  },
  {
    title: t('pages.journals.hjms.title'),
    coverImage: 'https://dergipark.org.tr/media/cache/journal_croped/fa78/4886/437a/5eed0e52d00a2.jpg',
    journalLink: 'https://dergipark.org.tr/en/pub/hujms',
    description: t('pages.journals.hjms.description'),
    indexes: [
      {
        name: 'TR Dizin',
        logo: 'https://dergipark.org.tr/media/cache/index_logo/8bc6/836b/4cf6/5bd95eb5f3a21.jpg',
        link: 'https://search.trdizin.gov.tr/tr/dergi/detay/281'
      },
      {
        name: 'Scopus',
        logo: 'https://dergipark.org.tr/media/cache/index_logo/c744/dfc3/599e/589c73e2330bd.jpg',
        link: 'https://www.scopus.com/sourceid/19400157155'
      },
      {
        name: 'Web of Science (Master Journal List)',
        logo: null,
        link: 'https://mjl.clarivate.com/home?PC=D&Alpha=H'
      }
    ]
  }
];

const SpecialRepublicSection = ({ journal, t }) => (
  <motion.div
    className="relative bg-gradient-to-br from-red-50 via-white to-red-50 border-4 border-red-600 rounded-3xl shadow-2xl p-8 mb-16 overflow-hidden"
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.1 }}
  >
    {/* Decorative elements */}
    <div className="absolute top-0 left-0 w-32 h-32 bg-red-100 rounded-full -translate-x-16 -translate-y-16 opacity-50"></div>
    <div className="absolute bottom-0 right-0 w-40 h-40 bg-red-100 rounded-full translate-x-20 translate-y-20 opacity-30"></div>

    {/* Turkish flag pattern */}
    <div className="absolute top-4 right-4 flex items-center space-x-2">
      <div className="w-8 h-5 bg-red-600 rounded-sm flex items-center justify-center">
        <div className="w-3 h-3 border border-white rounded-full flex items-center justify-center">
          <div className="w-2 h-2 bg-white rounded-full"></div>
        </div>
      </div>
    </div>

    <div className="relative z-10 flex flex-col lg:flex-row items-center justify-center space-y-8 lg:space-y-0 lg:space-x-12">
      <a href={journal.journalLink} target="_blank" rel="noopener noreferrer" className="block flex-shrink-0">
        <div className="relative group">
          <img
            src={journal.coverImage}
            alt={journal.title}
            className="w-72 h-auto object-contain rounded-2xl shadow-2xl transform transition-all duration-500 group-hover:scale-105 group-hover:rotate-1"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-red-600/20 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
      </a>

      <div className="text-center lg:text-left max-w-3xl">
        <div className="mb-6">
          <span className="inline-block bg-red-600 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg mb-4">
            {t('pages.journals.specialIssue')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-red-700 mb-2 leading-tight">
            {journal.title}
          </h2>
          <div className="text-red-600 font-semibold mb-2">
            <p className="text-lg">{journal.volume}</p>
            <p className="text-base">{journal.editor}</p>
          </div>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-red-400 mx-auto lg:mx-0 rounded-full"></div>
        </div>

        <p className="text-gray-700 leading-relaxed mb-8 text-lg whitespace-pre-line">
          {journal.description}
        </p>

                 <div className="flex justify-center lg:justify-start">
           <a
             href={journal.journalLink}
             target="_blank"
             rel="noopener noreferrer"
             className="inline-flex items-center justify-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 ease-in-out transform hover:scale-105 shadow-xl hover:shadow-2xl"
           >
             <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
               <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
             </svg>
             {t('pages.journals.readSpecialIssue')}
           </a>
         </div>
      </div>
    </div>
  </motion.div>
);

const JournalCard = ({ journal, index, t }) => (
    <motion.div
        className={`rounded-2xl shadow-lg overflow-hidden flex flex-col group ${journal.isFirstIssue ? 'bg-cream-light border-2 border-blue-900' : 'bg-white'}`}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.2 }}
    >
      <a
        href={journal.journalLink}
        target="_blank"
        rel="noopener noreferrer"
        className="block overflow-hidden bg-gray-100 h-64 relative cursor-pointer"
      >
        <img src={journal.coverImage} alt={journal.title} className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105" />
        {journal.isFirstIssue && (
            <span className="absolute top-4 left-4 bg-blue-900 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                {t('pages.journals.firstIssue')}
            </span>
        )}
      </a>
      <div className={`border-t border-b px-6 py-4 ${journal.isFirstIssue ? 'bg-cream-dark border-blue-800' : 'bg-gray-50 border-gray-200'}`}>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          {journal.indexes.map(indexItem => (
            <a href={indexItem.link} key={indexItem.name} target="_blank" rel="noopener noreferrer" title={indexItem.name} className="grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300">
              {indexItem.logo ? (
                <img src={indexItem.logo} alt={indexItem.name} className="h-8" />
              ) : (
                <span className="text-sm font-semibold text-blue-600 hover:underline">{indexItem.name}</span>
              )}
            </a>
          ))}
        </div>
      </div>
      <div className="p-6 flex-grow flex flex-col">
        <h3 className={`mb-3 ${journal.isFirstIssue ? 'text-2xl font-extrabold text-blue-900' : 'text-xl font-bold text-gray-800'}`}>{journal.title}</h3>
        <p className={`leading-relaxed whitespace-pre-line flex-grow ${journal.isFirstIssue ? 'text-gray-800 text-base' : 'text-gray-700 text-base'}`}>{journal.description}</p>
      </div>
    </motion.div>
);

const DergilerPage = () => {
    const { t } = useTranslation();
    const journals = getJournals(t);
    const specialIssueJournal = journals.find(journal => journal.isSpecialIssue);
    const firstIssueJournal = journals.find(journal => journal.isFirstIssue);
    const otherJournals = journals.filter(journal => !journal.isFirstIssue && !journal.isSpecialIssue);

    return (
        <PageTemplate
            title={t('pages.journals.pageTitle')}
            subtitle={t('pages.journals.pageSubtitle')}
        >
            {specialIssueJournal && (
                <SpecialRepublicSection journal={specialIssueJournal} t={t} />
            )}

            {firstIssueJournal && (
                <motion.div
                    className="bg-cream-light border-2 border-blue-900 rounded-2xl shadow-lg p-8 mb-12 flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-12"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                >
                    <a href={firstIssueJournal.journalLink} target="_blank" rel="noopener noreferrer" className="block flex-shrink-0">
                        <img
                            src={firstIssueJournal.coverImage}
                            alt={firstIssueJournal.title}
                            className="w-64 h-auto object-contain rounded-xl shadow-xl transform transition-transform duration-300 hover:scale-105 rotate-1"
                        />
                    </a>
                    <div className="text-center md:text-left">
                        <h2 className="text-3xl font-extrabold text-blue-900 mb-4">
                            {firstIssueJournal.title}
                            <span className="block text-base font-semibold text-blue-700 mt-1">{t('pages.journals.firstIssueJournal.subtitle')}</span>
                        </h2>
                        <p className="text-gray-800 leading-relaxed mb-6 max-w-prose">
                            {firstIssueJournal.description}
                        </p>
                        <a
                            href={firstIssueJournal.journalLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-8 rounded-lg transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
                        >
                            {t('pages.journals.readJournal')}
                        </a>
                    </div>
                </motion.div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 my-12">
                {otherJournals.map((journal, index) => (
                    <JournalCard
                        key={journal.title}
                        journal={journal}
                        index={index}
                        t={t}
                    />
                ))}
            </div>
        </PageTemplate>
    );
};

export default DergilerPage; 